import React from 'react';
import SamuraiGame from '../SamuraiGame';

const TwentyFiveYardShot = () => {
    return <SamuraiGame initialDrillIndex={3} />;
};

export default TwentyFiveYardShot;
